import React, { useMemo } from "react";
import { FaCrown, FaSpinner } from "react-icons/fa";

import {
  daysArray,
  getAdherentName,
  getMonthlyCellMeta,
} from "../utils/attendanceUtils";

function getSavingKey(adherentId, day) {
  return `${adherentId}-${day}`;
}

export default function AttendanceMonthlyMobileCards({
  month,
  rows = [],
  highlightIds = [],
  savingCells = new Set(),
  onToggleCell,
}) {
  const days = useMemo(() => (month ? daysArray(month) : []), [month]);

  const highlightSet = useMemo(
    () => new Set((highlightIds || []).map(Number)),
    [highlightIds],
  );

  if (!month || rows.length === 0) return null;

  return (
    <div className="space-y-4 md:hidden">
      {rows.map((row) => {
        const isTop = highlightSet.has(Number(row.id));

        return (
          <article
            key={row.id}
            className="overflow-hidden rounded-[24px] border border-slate-200 bg-white shadow-sm dark:border-slate-800 dark:bg-slate-950/60"
          >
            <div
              className={`p-4 ${
                isTop
                  ? "bg-amber-50 dark:bg-amber-900/20"
                  : "bg-slate-50 dark:bg-slate-900"
              }`}
            >
              <div className="flex items-start justify-between gap-3">
                <div className="min-w-0">
                  <h3 className="truncate text-base font-bold text-slate-900 dark:text-white">
                    {getAdherentName(row.adherent)}
                  </h3>

                  <p className="mt-1 text-xs text-slate-500 dark:text-slate-400">
                    {row.totalPresent} présent
                    {row.totalPresent > 1 ? "s" : ""} · {row.totalAbsent}{" "}
                    absent{row.totalAbsent > 1 ? "s" : ""} · {row.rate}%
                  </p>
                </div>

                {isTop && (
                  <span className="inline-flex items-center gap-1 rounded-full bg-amber-400 px-2.5 py-1 text-xs font-bold text-white shadow-sm">
                    <FaCrown />
                    Top
                  </span>
                )}
              </div>
            </div>

            <div className="grid grid-cols-7 gap-2 p-4">
              {days.map((day) => {
                const value = row.dates?.[day];
                const meta = getMonthlyCellMeta(value);
                const saving = savingCells.has(getSavingKey(row.id, day));

                return (
                  <button
                    key={day}
                    type="button"
                    onClick={() => onToggleCell?.(row.id, day, value)}
                    disabled={saving}
                    className={`flex h-11 flex-col items-center justify-center rounded-xl text-[10px] font-bold ring-1 transition active:scale-95 disabled:cursor-wait disabled:opacity-70 ${meta.className}`}
                    title={`${day} : ${meta.label}`}
                  >
                    <span>{day}</span>

                    <span className="mt-0.5 text-[10px]">
                      {saving ? (
                        <FaSpinner className="animate-spin" />
                      ) : (
                        meta.short || "—"
                      )}
                    </span>
                  </button>
                );
              })}
            </div>
          </article>
        );
      })}
    </div>
  );
}